import { TBurgerMenu } from './components/burger-menu/types';
import { TIoTDevice, TIoTDeviceType, TIoTGroup } from './components/iot-menu/types';

export type TMenuColors = {
  bg: string;
  hover: string;
  text: string;
  open: string;
  search: string;
  scrollbar: string;
  btnBg: string;
  btnHover: string;
  btnText: string;
  iotBg: string;
  bmBg: string;
  iotText: string;
  bmText: string;
};

export type TMenuContact = {
  phone: string;
  onClick: () => void;
};

export type TMenuAddress = {
  label: string;
  onClick: () => void;
};

export type TMenuBook = {
  url: string;
  label: string;
};

export enum EMenuOpenType {
  BM = 'bm',
  IoT = 'iot',
}

export type TMenuSettings = {
  alwaysOpen: boolean;
  tooltipOnBm?: boolean;
  tooltipOnIot?: boolean;
  search: boolean;
  categoryExpand: boolean;
  transparent: boolean;
  fullScreenMobile: boolean;
  openOnHoverBm?: boolean;
  openOnHoverIot?: boolean;
  openOnLaunch: boolean;
};

export type TMenuWhitelabel = {
  website: string;
  logo: string;
};

export type Props = {
  onBMOpen?: () => void;
  sendToGA: (type: string, obj: any, isMultiPaths?: boolean) => void;
  onIoTOpen?: () => void;
  onBMClose?: () => void;
  onIoTClose?: () => void;
  sendTagToGA: (sid: string) => void;
  onWidthChange?: (width: number) => void;
  moveToMPLabels?: (menu: TBurgerMenu) => void;
  loadModel?: (...args: any[]) => void;
  open: boolean;
  openType: EMenuOpenType;
  parentMenus: any[];
  minimapHeight?: number;
  hideTriggerButton?: boolean;
  currentSid?: string;
  whitelabel?: TMenuWhitelabel;
  rtl: boolean;
  settings: TMenuSettings;
  colors: TMenuColors;
  book?: TMenuBook;
  contact?: TMenuContact;
  address?: TMenuAddress;
  showBothTriggers?: boolean;
  translation?: Record<string, string>;
  iotGroups: TIoTGroup[];
  iotDevices: TIoTDevice[];
  iotDevicesTypes: TIoTDeviceType[];
  providers: any[];
  // used for Action Type Menu
  activeMenuId?: number;
  handleLock?: (d: TIoTDevice) => void;
  handleMoveToLock?: (d: TIoTDevice) => void;
  handleItemClickLuma?: (item: TBurgerMenu) => void;
  libraryIconsBaseUrl: string;
  awsIconUrl: string;
  handleOpenCamera?: ({
    multiCams,
    openCamera,
  }: {
    openCamera?: TIoTDevice;
    multiCams?: { id: number; tourId: number; name?: string; cameras: number[] | null };
  }) => void;
  favouriteCameras?: { id: number; tourId: number; name?: string; cameras: number[] | null }[];
};

export type MenuWrapperProps = Props;
